import IEO from "../../components/Olympiad/ClassTwo/IEO";
import IGKO from "../../components/Olympiad/ClassTwo/IGKO";
import IMO from "../../components/Olympiad/ClassTwo/IMO";
import NCO from "../../components/Olympiad/ClassTwo/NCO";
import NSO from "../../components/Olympiad/ClassTwo/NSO";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/olympiad-classtwo/nso", title: "National Science Olympiad (NSO)", component: NSO },
    { url: "/olympiad-classtwo/imo", title: "International Mathematics Olympiad (IMO)", component: IMO },
    { url: "/olympiad-classtwo/nco", title: "National Cyber Olympiad (NCO)", component: NCO },
    { url: "/olympiad-classtwo/igko", title: "International General Knowledge Olympiad (IGKO)", component: IGKO },
    { url: "/olympiad-classtwo/ieo", title: "International English Olympiad (IEO)", component: IEO },
    // { url: "/olympiad-classtwo/nstse", title: "National-level Science Talent Search Examination (NSTSE)" }
];

export default topics;